import React from "react";
import "./styles/SaaSTestBedOverView.scss";
import BannerType1 from "./BannerType1";
import { useTranslation } from "react-i18next";
const SaaSTestBedOverView = () => {
  const { t } = useTranslation();
  const content = t("digitalTwin.testBed.floor.contents", { returnObjects: true }) as {
    image: string;
    title: string;
    sections: {
      title: string;
      items: string[];
    }[];
  }[];
  return (
    <>
      <div className="saas_test_bed_overview">
        <BannerType1 path="/imgs/banner_testbed_overview.png" />
        <h2 className="title">{t("digitalTwin.testBed.overView.title")}</h2>
        <div className="overview">
          <img src="/imgs/testbed_overview.png" alt="testbed_overview" />
        </div>
        <div className="floor_wrap">
          <div className="title">{t("digitalTwin.testBed.floor.title")}</div>
          <div className="upper">
            <div className="img_box">
              <img src="/imgs/testbed_floor_upper_01.png" alt="floor" />
            </div>
            <div className="img_box">
              <img src="/imgs/testbed_floor_upper_02.png" alt="floor" />
            </div>
          </div>
          <div className="under">
            {content.map(
              (
                data: {
                  image: string;
                  title: string;
                  sections: { title: string; items: string[] }[];
                },
                index: number,
              ) => {
                return (
                  <div className="card" key={`${data.title}_${index}`}>
                    <div className="img_box">
                      <img src={data.image} alt={data.title} />
                    </div>
                    <div className="name">{data.title}</div>
                    <div className="list_wrap">
                      {data.sections.map((sections: { title: string; items: string[] }, index2: number) => {
                        return (
                          <ul key={`${sections.title}_${index2}`}>
                            <div className="text">{sections.title}</div>
                            {sections.items.map((text: string, index3: number) => {
                              return <li key={`${text}_${index3}`}>{text}</li>;
                            })}
                          </ul>
                        );
                      })}
                    </div>
                  </div>
                );
              },
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SaaSTestBedOverView;
